<table class="table-primary">
  <thead>
  <tr>
    <th (click)="sortByColumn('friendlyName')" class="text-left sort drug" scope="col">
      Drug
      <img [class.asc]="tableColumns.friendlyName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('allLocationsOnHand')" class="text-right sort all-on-hand" scope="col" *ngIf="inventoryLocationsEnabled">
      <div class="flex items-center justify-end">
        <div class="flex flex-col">
          <div>All LOC</div>
          <div>On-hand</div> 
        </div>
        <img [class.asc]="tableColumns.allLocationsOnHand" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </div>
    </th>
    <th (click)="sortByColumn('onHand')" class="text-right sort on-hand" scope="col" *ngIf="!inventoryLocationsEnabled">
      On-hand
      <img [class.asc]="tableColumns.onHand" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('onHand')" class="text-right sort on-hand" scope="col" *ngIf="inventoryLocationsEnabled">
      <div class="flex items-center justify-end">
        <div class="flex flex-col">
          <div>SEL LOC</div> 
          <div>On-hand</div>
        </div>
        <img [class.asc]="tableColumns.onHand" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </div>
    </th>
    <th (click)="sortByColumn('similarOnHand')" class="text-right sort on-hand" scope="col">
      SOH
      <img [class.asc]="tableColumns.similarOnHand" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th (click)="sortByColumn('lastActivityTransactionDate')" class="text-left sort activity" scope="col">
      Last Activity
      <img [class.asc]="tableColumns['lastActivityTransactionDate']" class="sort-icon"
           src="assets/icons/icon-arrow-down.svg" alt="asc"/>
    </th>
    <th class="text-left activity" *ngIf="inventoryLocationsEnabled">
      Locations
    </th>
    <th (click)="sortByColumn('lastAuditDetailConfirmationDate')" class="text-left sort last-audit" scope="col">
      <div class="flex items-center">
        <div class="flex flex-col items-end">
          <div>Last</div>
          <div>Audit Date</div>
        </div>
        <img [class.asc]="tableColumns['lastAuditDetailConfirmationDate']" class="sort-icon"
             src="assets/icons/icon-arrow-down.svg" alt="asc"/>
      </div>
    </th>
    <!-- <th class="text-right controls" scope="col">
    
    </th> -->
  </tr>
  </thead>
  <tbody appOverflowClass>
  <tr class="table-row"
      (click)="openSingleRecordTable(rowData)"
      *ngFor="let rowData of inventoryList"
  >
    <th class="text-left drug" scope="row">
      <div class="heading">
        {{rowData.friendlyName}}
      </div>
      <div class="secondary">
        {{rowData.packageNdc}}
      </div>
    </th>
    <td class="text-right all-on-hand" *ngIf="inventoryLocationsEnabled">
      {{rowData.allLocationsOnHand | number}}
    </td>
    <td class="text-right on-hand">
      {{rowData.onHand | number}}
    </td>
    <td class="text-right on-hand" (click)="$event.stopPropagation(); openSohReport(rowData)">
      {{rowData?.similarOnHand | number}}
    </td>
    <td class="text-left activity">
      <app-badge [color]="(rowData | transactionBadge)?.color">
        {{(rowData | transactionBadge)?.label}}
      </app-badge>
     
      <div class="secondary">
        <div class="formatted-date">
          {{rowData?.lastActivityTransactionDate | formattedDate: 'MMM d a, HH:mm yyyy'}}
        </div>
        <div class="name">
          <ng-container *ngIf="rowData.lastActivityFirstName">
            {{rowData.lastActivityFirstName}}
          </ng-container>
          <ng-container *ngIf="rowData.lastActivityLastName">
            {{rowData.lastActivityLastName[0]}}.
          </ng-container>
        </div>
      </div>
    </td>

    <td class="text-left activity" *ngIf="inventoryLocationsEnabled">
      <div class="locations-container">
        <div *ngFor="let location of rowData?.locations; let i = index" class="inline-block mr-1">
          <span class="location">{{location.locationName}}
            <span [hidden]="rowData?.locations?.length - 1 === i">,</span> 
          </span>
        </div>
      </div>
      
    </td>

    <td class="text-left last-audit" scope="row" (click)="goToAudit(rowData.auditId)">
      <div class="heading">
        {{rowData?.lastAuditDetailConfirmationDate | formattedDate: 'MM d a, HH:mm'}}
      </div>
      <div class="secondary" *ngIf="rowData?.auditCompleteByFirstName">
        {{rowData?.auditDetailConfirmedByFirstName}} {{rowData?.auditDetailConfirmedByLastName[0]}}.
      </div>
    </td>
    <!-- <td class="text-right controls" >
      <button *ngIf="false"
              class="table-menu-btn"
              appMenu
              [placement]="'bottom-right'"
              [autoClose]="'outside'"
              [menuContent]="tableRowMenuContent"
              triggers="manual"
              #tableRowMenu="appMenu"
              (click)="tableRowMenu.toggle();$event.stopPropagation();"
      >
        <img src="assets/icons/icon-three-dots.svg" alt="table-row-menu"/>
      </button>
      <ng-template #tableRowMenuContent>
        <div class="menu-container primary">
          <div (click)="openArchiveDialog(rowData);tableRowMenu.close();$event.stopPropagation()"
               class="menu-item"
          >
            <div class="option">
              Archive NDC
            </div>
          </div>
        </div>
      </ng-template>
    </td> -->
  </tr>
  </tbody>
</table>

<!-- ARCHIVE NDC DIALOG -->
<app-warning-dialog [show]="showArchiveNDCDialog"
                    header="Are you sure you want to archive this NDC?"
                    description="An archived drug can be un-archived later from the Archived tab."
                    acceptBtnText="Yes, archive this NDC"
                    (cancel)="closeArchiveNDCDialog()"
                    (next)="archiveNDC()"
></app-warning-dialog>
